
export const d11_color = {
    'primary-color': 'rgb(183, 0, 255)',
}
export const gamerji = {
    'primary-color': 'blue'
}